import { ScrollTrigger } from "gsap/ScrollTrigger";

export const init = () => {
  const stickyElements = document.querySelectorAll(".js-sticky");

  if (!stickyElements.length) return;

  stickyElements.forEach((el, index) => {
    let offset = 0;

    for (let i = 0; i < index; i++) {
      offset += stickyElements[i].offsetHeight;
    }

    el.style.top = `${offset}px`;
    el.classList.add("is-sticky");

    ScrollTrigger.create({
      trigger: el,
      start: "top top",
      onEnter: () => el.classList.add("is-sticky-active"),
      onLeaveBack: () => el.classList.remove("is-sticky-active"),
      invalidateOnRefresh: true,
    });
  });
};
